export class GetHints {
  static readonly type = '[Hint] Get Hints';

  constructor() {}
}
